/**
 * The current time. In development, this can be overridden with a fake clock (see `lib/dev/clock`).
 *
 * @returns {number} Epoch milliseconds
 */
export const now = () => {
	// Must stay a literal `process.env.NODE_ENV` check around a `require()` (not a top-level
	// `import`): the build inlines NODE_ENV, and webpack never follows a `require()` in a branch it
	// can prove is dead -- which is what keeps `lib/dev` out of the production bundle entirely.
	if (process.env.NODE_ENV !== 'production') {
		return require('../dev/clock.js').now();
	}
	return Date.now();
};
